
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import { Bootstrapper } from "Bootstrapper"
import { UseBusyIndicatorStore, Update as BusyUpdate } from 'stores/BusyIndicatorStore';
import LoadingButton from "components/buttons/LoadingButton"
import { CommonUtil } from "utils/CommonUtil"


const EmailResetRequestConfirm = (props: any) => {
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];

    const userService = new UserService();
    const [searchParams] = useSearchParams();
    const [linkRequested, setLinkRequested] = useState<boolean>(false);
    const [canSubmit, setCanSubmit] = useState<boolean>(true);
    const [email, setEmail] = useState<string>();
    const [validationMsg, setValidationMsg] = useState<string>("");
    const [token, setToken] = useState<string>();
    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);

    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }


    useEffect(() => {
        loadDataAsync();
    }, []);


    const loadDataAsync = async() => {
        BusyUpdate(true);
        const t = searchParams.get("token");
        const newEmail = searchParams.get("newEmail");
        setToken(t);
        setEmail(newEmail);
        BusyUpdate(false);        

    }


    const onRequestResetLinkAsync = async() => {
        if(!canSubmit)
            return;
        setValidationMsg("");
        if(CommonUtil.isNullOrEmpty(email)){
            setValidationMsg("Email is required");
            return;
        }

        if(CommonUtil.isNullOrEmpty(token)){
            setValidationMsg("Token is required");
            return;
        }

        setCanSubmit(false);

        var result = await userService.confirmEmailUpdateRequestAsync(token, email).catch((err: Error) => {
            setValidationMsg(err.message);
        });
        setLinkRequested(result === true);
        setCanSubmit(true);
    }

    const action = linkRequested ? null : <LoadingButton loading={!canSubmit} disabled={!canSubmit} onClick={() => onRequestResetLinkAsync()} fullWidth>Proceed</LoadingButton>;
    return(
        <Section sx={{flexGrow: 1}} id="section-plans" bgColor={bg2}>
            <Container maxWidth="xs">
                <Animation overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='fade' direction='left' transitionDelay={0}>
                    <div>
                    <Form 
                    validationMsg={validationMsg}
                    action={
                        <Box>
                            {action}
                            {linkRequested && <Text mt={1} variant="caption">Request a new <Link onClick={() => onRequestResetLinkAsync()} to={""}>link</Link></Text>}

                        </Box>                        
                    }
                    title={linkRequested ? "Link Sent!" : "New Email"}>
                            {!linkRequested && <Text align='center' sx={{wordBreak: 'break-word'}}>Are you sure you want to change your email to <strong>{email}</strong>?</Text>}
                            {linkRequested && <Text>Check your new email ({email}) for a link to finalize your new email</Text>}
                    </Form>
                    </div>

                </Animation>
            </Container>
        </Section>
    )

}

export default EmailResetRequestConfirm
